{
  "en": {
    "decision": {
      "actions": {
        "add": "Add",
        "addDocument": "Add document",
        "addUnits": "Units",
        "approve": "Approve",
        "autoCloseAfterApproval": "Auto-close after approval",
        "autoCloseAfterApprovalInfo": "Decision closes when a proposal is approved",
        "autoCloseAfterDeadline": "Auto-close after deadline",
        "cancel": "Undo",
        "changeResponsible": "Change responsible",
        "clickToSetDeadline": "Click to set deadline",
        "closeDecision": "Close decision",
        "confirmChoices": "Confirm choices",
        "createProposal": "Create proposal",
        "create_decisions": "Create decision | Create decisions",
        "delete": "Delete",
        "deleteCount": "You are about to delete {count} decision. Are you sure? | You are about to delete {count} decisions. Are you sure?",
        "deleteMultipleDecisions": "Delete...",
        "delete_cancel": "Cancel",
        "delete_decisions": "Delete decision | Delete decisions",
        "edit": "Edit",
        "editBudget": "Edit budget",
        "editDeadline": "Edit deadline",
        "editDecision": "Edit decision",
        "editReminders": "Edit reminders",
        "goToDecision": "Go to decision",
        "goToProposal": "Go to proposal",
        "goToSummary": "Go to summary",
        "hide": "Unpublish",
        "hideInfo": "Hide info",
        "noDescription": "Click to add a description",
        "openDecision": "Open decision",
        "publish": "Publish",
        "publishAll": "For all",
        "publishCustomer": "Publish for customer",
        "publishPartners": "Publish for partner(s)",
        "reject": "Reject",
        "relaunch_decision": "Relaunch decision",
        "request_changes": "Request changes",
        "reset": "Reset",
        "save": "Save",
        "save_and_share_partners": "Save and share with partners",
        "selectAll": "Select all {total} units",
        "selectChoices": "Select choices",
        "share_proposals": "Share proposals",
        "showMoreInfo": "Show more info",
        "stopApproving": "Stop approving",
        "submit": "Submit",
        "tickBoxesDeletion": "Tick the checkboxes of the files you would like to have deleted.",
        "unSelectAll": "Clear selection.",
        "unpublishForCustomer": "Unpublish for customer",
        "unpublishForPartners": "Unpublish for decision partner",
        "update": "Update",
        "upload": "Upload",
        "upload_documents": "Upload documents",
        "upload_proposals": "Upload proposals"
      },
      "attributes": {
        "amount_gross": "Gross offer",
        "amount_net": "Net offer",
        "approved_at": "Approval date proposal",
        "approved_proposal_name": "Approved proposal",
        "bathrooms": "Number of bathrooms",
        "bedrooms": "Number of bedrooms",
        "category": "Category",
        "customer_group_name": "Customer",
        "decision_name": "Decision",
        "decisions_count": "{count} decision | {count} decisions",
        "due_date": "Deadline",
        "floor": "Storey",
        "negative_surcharges_allowed": "Allow credit",
        "note_employee": "Note",
        "price_budget": "Budget",
        "price_budget_extra": "Extra budget",
        "price_budget_info": "You can always edit the budget later",
        "price_budget_info_mup": "You can always edit the budget per unit later",
        "price_margin": "Margin",
        "price_surcharge": "Upgrade",
        "published": "Published",
        "responsible": "Responsible",
        "status": "Status",
        "unit": "Unit",
        "verification_type": "Approval decision given by",
        "visibility": "Visibility"
      },
      "edit_actions": {
        "edit_auto_close": "Auto close options",
        "edit_close_decision": "Close/Open decision",
        "edit_deadline": "Set deadline",
        "edit_margin": "Set margins",
        "edit_negative_surcharges_allowed": "Allow credit",
        "edit_note_employee": "Edit note",
        "edit_price_budget": "Set budget",
        "edit_price_budget_extra": "Set extra budget",
        "edit_reminders": "Set reminders",
        "edit_responsible": "Set responsible"
      },
      "labels": {
        "accessRights": "Access rights",
        "activity": "Activity",
        "addDecisionNote": "Add note",
        "addReminders": "Add reminders",
        "allUnits": "All units",
        "allUnitsAssigned": "All units assigned",
        "allow_not_interested": "Allow 'Not interested' option",
        "allow_not_interested_info": "Shows a 'Not interested' option next to the proposals",
        "approved": "Approved",
        "approvedAt": "Approved {approved_at}",
        "approvedProposal": "Approved Proposal",
        "askQuestion": "Ask here your questions regarding your decision {decision}",
        "assignCustomerToUnit": "Assign Customer",
        "autoClose": "Auto close",
        "budgetOverview": "Budget overview",
        "budgetSubtitle": "Input a budget here if it applies to all selected units or add budgets later",
        "budgetTitle": "Setting a budget",
        "checkbox": "Checkbox",
        "clickHereToChange": "Click here if you want to change them.",
        "close": "Close",
        "closeDecision": "Close decision",
        "closed": "The decision is closed for this unit. The customer won't be able to approve a proposal anymore.",
        "closedLabel": "Closed",
        "closed_tag": "Decision closed",
        "closed_tooltip_customer": "The decision is closed. You won't be able to approve a proposal anymore.",
        "countDocuments": "No documents yet | 1 document | {count} documents",
        "countEdit": "Edit the decision of {count} unit | Edit the decision of {count} units",
        "countUpload": "Upload document(s) to this unit | Upload document(s) to {count} units",
        "created_on": "Decision created on {date}",
        "custom_columns_title": "You can add up to 10 columns",
        "customer": "Customer",
        "customer_status": "Customer status",
        "decided": "Decided",
        "decision": "Decision",
        "decisionBreadcrumb": "Decision {decision_type}",
        "decisionNotPublishedYetFor": "Decision not published yet for",
        "decisionNoteExplainer": "This note is only visible for your team and for the partners that are allowed to see this decision",
        "decisionType": "Decision Subject",
        "decisionUnit": "Decision for unit {unit}",
        "decisions": "Decisions",
        "decisions_all_projects": "Decisions all projects",
        "decisions_breadcrumb": "Decisions {project}",
        "default": "Default",
        "deleteExplanation": "All communication messages, files, proposals and other data will be permanently removed from the platform. Customers and partners related to these decisions will lose all access.",
        "descriptionSubtitle": "Here you can add more information for your customers",
        "descriptionTitle": "Add a description for your customer",
        "documentRequired": "Signed document required for approval",
        "documentUnits": "Unit folder",
        "documents": "Documents",
        "dueDate": "Due {date}",
        "due_date_subtitle": "Set a date by which the decision has to be made",
        "due_date_title": "Deadline and reminders",
        "editDecisionNote": "Edit note",
        "extra_options": "Extra options",
        "false": "No",
        "filter": "Filter",
        "finalSettings": "Some optional settings",
        "finalSettingsStep": "Final settings",
        "financial": "Financial",
        "firstThingsfirst": "First things first, some general information",
        "follow": "Follow",
        "following": "Following — you will receive notifications",
        "four": "4",
        "giveNewAmount": "Give in new amount",
        "hideCount": "Unpublish this decision for 1 unit | Unpublish decision for {count} units",
        "hideVisibilitySettings": "Hide visibility settings",
        "indicate_not_interested": "Indicate customer is not interested in this decision",
        "info": "Show more info",
        "infoCustomers": "Customer details",
        "information": "Information",
        "make_a_decision": "Make a decision",
        "marginOnBudget": "Margin on budget (%)",
        "marginOnUpgrades": "Margin on upgrades (%)",
        "marginOnUpgradesExplainer": "The margin on upgrades will also be used on the extra budgets you give to a customer. The extra budget can be set within the decision of a unit.",
        "marginOverview": "Margin overview",
        "marginSubTitle": "Automatically calculate margins as percentages",
        "marginTitle": "Use margin percentages",
        "members": "Members",
        "modifyLater": "You can modify these settings later",
        "name": "Name",
        "newActivity": "New activity",
        "newDocument": "New document(s)",
        "next": "Next",
        "no": "No",
        "noApprovedProposalYet": "No proposal accepted yet",
        "noBudget": "No budget defined",
        "noCustomer": "No customer yet",
        "noCustomerAssigned": "No customer assigned to unit yet",
        "noDeadline": "No deadline",
        "noDecisionDueDate": "Select a deadline",
        "noDecisionStartDate": "No start date set",
        "noDecisionsMade": "No decisions made yet",
        "noDecisionsToMake": "No decisions to make.",
        "noDecisionsYet": "No decisions yet",
        "noDocumentsShared": "No documents shared",
        "noDueDate": "Set a deadline first before setting reminders",
        "noDueDateSet": "No deadline set",
        "noExtraBudget": "No extra budget",
        "noMessages": "Write your first message for {decision} in the box below",
        "noUnitDocuments": "No documents added to the Unit folder yet",
        "noUnitsClick": "No units yet, click here to add",
        "no_result_for_search": "No result for this filtered search.",
        "no_surcharges": "No surcharges",
        "no_surcharges_info": "Proposals without financial surcharges",
        "notDecided": "Not decided yet",
        "notDecidedYet": "The customer has not made a decision yet.",
        "notFollowing": "Not following — click to receive notifications",
        "notPossibleToWriteMessageDeactivatedUnit": "This decision is related to a deactivated unit. Writing a new message is not possible anymore.",
        "notPublished": "Not published",
        "notPublishedCustomer": "Decision not published yet for customer",
        "notPublishedPartners": "Decision not published yet for decision partners",
        "notShared": "Not shared",
        "not_interested": "Not interested",
        "not_interested_customer": "Not interested",
        "not_interested_customer_info": "If you are not interested in this decision, or this decision is not relevant to you, please click here to indicate it.",
        "not_interested_modal": {
          "customer": {
            "body": "Please provide some additional feedback as to why you are not interested in this decision",
            "title": "I am not interested in this decision"
          },
          "employee": {
            "body": "Please provide some additional feedback as to why the customer is not interested in this decision. This feedback will also be visible for the customer.",
            "title": "Customer is not interested in this decision"
          },
          "feedback": "Feedback"
        },
        "one": "1",
        "open": "Open",
        "openDecisionInfo": "This decision is open. The customer can approve proposals.",
        "open_auto_close_deadline_unit": "Set whether the decision will auto close or not on passing the deadline",
        "open_auto_close_unit": "Set whether the decision will auto close or not on approval ",
        "open_close_unit": "the decision for 1 unit | the decision for {unit_count} units",
        "or": "or",
        "participants": "Participants",
        "partners": "Decision partners",
        "pendingDecisions": "1 decision to make | {count} decisions to make",
        "priceBudget": "Budget",
        "priceBudgetExtra": "Extra budget",
        "proposal": "Proposals",
        "proposals": "Proposals | 1 proposal | {count} proposals",
        "publish?": "Save and publish?",
        "publishNow?": "Publish now?",
        "publishTopOfPage": "You can publish this decision at the top of this page",
        "publishedCount": "Publish this decision for 1 unit | Publish decision for {count} units",
        "publishedCustomer": "Decision published for customer",
        "publishedCustomerPartners": "Decision published for customer & decision partners",
        "publishedNone": "Not published yet",
        "publishedPartners": "Decision published for decision partners",
        "publishedSince": "Decision published since {date}",
        "published_info": "Shows if all units have been published for customers and/or decision partners",
        "remainOpen": "Remain open",
        "reminders": "Reminders",
        "remindersCount": "1 reminder | {count} reminders",
        "reopenDecision": "Reopen decision",
        "requiresDocumentVerification": "Requires signed document for approval",
        "requiresNoDocumentVerification": "No signed document required for approval",
        "returnToTickets": "Go back",
        "rights": {
          "access_full": "Full access",
          "access_none": "Restricted access",
          "access_semi": "Basic access",
          "customer_show": "Can see the customer information.",
          "default": "Decision partners can send messages, upload documents and create proposals to <b>{client_name}</b> at any time. They also have access to the plans in the unit documents folder. Below you can edit their communication rights towards your customers.",
          "document_customer": "Can share their documents directly with the customer.",
          "message_customer": "Can send messages to the customer.",
          "proposal_customer": "Can share their proposals directly with the customer."
        },
        "save?": "Save?",
        "saveExplainer": "Make this decision visible for your customers? Or save and publish later?",
        "select": "Select",
        "selectOneUnit": "Select at least 1 unit",
        "selectUnits": "Select units",
        "select_units": "Select units",
        "selected": "{selected} unit selected. | {selected} units selected.",
        "sharedWith": "Shared with",
        "showDecisionsFor": "Show decisions for",
        "show_all_units": "Show all units",
        "signOnline": "Type name to confirm (default)",
        "signUploadDocument": "Upload signed document",
        "signedDocument": "Upload signed document",
        "status": "Status",
        "statusExplained": "What does each decision status mean?",
        "step2Subtitle": "Select your project to include all your units at once.",
        "step2Title": "Which units have to make a decision?",
        "step2TitleWithDecisionName": "Which units have to make a decision for {decision_name}?",
        "subject": "Subject",
        "summary": "Summary",
        "surcharge_tooltip": "This is the upgrade for this decision",
        "surcharges_total": "Upgrades: {total}",
        "surcharges_total_tooltip": "This is the total amount of upgrades for all units that have an upgrade",
        "three": "3",
        "tickets": "Conversations",
        "toBeDecided": "To be decided",
        "toDecide": "To decide",
        "total": "Total",
        "totalSelected": "All {total} units are selected.",
        "true": "Yes",
        "two": "2",
        "type": "Type",
        "unitDecisionsWillBeShownHere": "Unit decisions will be shown here",
        "unitNotActivated": "Only for activated units",
        "unitSelected": "No unit | One unit | {count} units",
        "unit_name": "Unit",
        "units": "Units",
        "unpublish": "Not published",
        "unpublished": "Unpublished",
        "uploadDocument": "Upload documents",
        "useMargins": "Activate margin percentages",
        "use_surcharges": "Use surcharges",
        "use_surcharges_info": "Set a budget for surcharges",
        "validation_errors": "There are issues with this proposal. Please solve them first and then try again.",
        "waitingForClient": "Waiting for client",
        "whatTheCustomerHasBought": "What the customer has bought",
        "when": "When",
        "who": "Who",
        "withAll": "All",
        "withClient": "With {client} only",
        "withCustomer": "With Customer",
        "withCustomerName": "With {customer}",
        "withPartners": "With decision partners only",
        "yes": "Yes"
      },
      "legend": {
        "all": "All decisions",
        "approved": "Decided",
        "approvedAfterDue": "Proposal approved after deadline",
        "created": "No proposal yet",
        "decisionApproved": "Decided",
        "hasDecision": "No proposal yet",
        "hasProposal": "Proposal uploaded",
        "has_proposal": "To be decided",
        "isExpired": "Deadline expired, no proposal uploaded",
        "isExpiredHasProposal": "Deadline expired, proposal uploaded",
        "noDecision": "Unit excluded for this decision",
        "not_interested": "Not interested",
        "other_decisions": "Other decisions",
        "requested_changes": "Changes requested",
        "waiting_for_proposal": "Waiting for proposal"
      },
      "navigation": {
        "backToDecisions": "Back to decisions"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "New decisions will come soon!",
            "title": "Get ready to make a decision"
          },
          "no_documents": {
            "subtitle": "Here you'll find all the documents related to this decision",
            "title": "Upload documents related to decision {decision_name}"
          }
        },
        "employees": {
          "conversations": {
            "none": {
              "subtitle": "From the moment there is a customer assigned to this unit you will see conversations here",
              "title": "Here you'll find all conversations for this decision"
            }
          },
          "new": {
            "subtitle": "Assign a decision to multiple units in 1 go",
            "title": "Create your first Decision"
          }
        },
        "partners": {
          "none": {
            "subtitle": "You will receive an email notification when a new decision is published.",
            "title": "You don't have any decisions yet"
          }
        }
      },
      "toasts": {
        "bulk_create": "Decision successfully created | Decisions successfully created",
        "bulk_delete": "Decision successfully deleted | Decisions successfully deleted",
        "bulk_update": "Decision successfully updated | Decisions successfully updated",
        "update": "Decision successfully updated"
      },
      "validation": {
        "amountRequired": "Amount is required",
        "cannotUpdatePrice": "Budget cannot be edited since installments based on this decision have been made visible for the customer",
        "customer": {
          "need_not_interested_note": "Please give feedback on why you are not interested in this decision"
        },
        "employee": {
          "need_not_interested_note": "Please give feedback on why the customer is not interested in this decision."
        },
        "installmentsSent": "Some selected decisions have installments visible for the customer. Their budget will remain the same.",
        "mustBeZeroOrMore": "Must be 0 or more",
        "needAttachment": "Upload at least one new document or select one from the unit folder",
        "needNumber": "Need a number (e.g. 8400.5)",
        "needTitle": "Title is required",
        "need_responsible": "Need a responsible",
        "priceBudgetNotNegative": "Budget can not be a negative number.",
        "responsibleRequired": "Responsible required",
        "selectContactPerson": "Select at least 1 contact person"
      }
    }
  }
}
